import { API_ROOT } from "config.js";

const USER_GROUPS_ENDPOINT = `${API_ROOT}/api/user-groups/`;
const MISSIONS_ENDPOINT = `${API_ROOT}/api/missions/`;
const GOALS_ENDPOINT = `${API_ROOT}/api/goals/`;

async function unwrapResponse(response) {
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  return response.data;
}

export async function getUserGroups(axios) {
  const response = await axios.get(USER_GROUPS_ENDPOINT);
  return unwrapResponse(response);
}

export async function createUserGroup(axios, payload) {
  const response = await axios.post(USER_GROUPS_ENDPOINT, payload);
  return unwrapResponse(response);
}

export async function inviteUsersToGroup(axios, groupId, payload) {
  const response = await axios.post(
    `${USER_GROUPS_ENDPOINT}${groupId}/invite/`,
    payload
  );
  return unwrapResponse(response);
}

export async function searchUsers(axios, query) {
  const response = await axios.get(
    `${USER_GROUPS_ENDPOINT}search-users/?q=${encodeURIComponent(query)}`
  );
  return unwrapResponse(response);
}

export async function getMissions(axios) {
  const response = await axios.get(MISSIONS_ENDPOINT);
  return unwrapResponse(response);
}

export async function createMission(axios, payload) {
  const response = await axios.post(MISSIONS_ENDPOINT, payload);
  return unwrapResponse(response);
}

export async function updateMission(axios, id, payload) {
  const response = await axios.patch(`${MISSIONS_ENDPOINT}${id}/`, payload);
  return unwrapResponse(response);
}

export async function createMissionGoal(axios, payload) {
  const response = await axios.post(GOALS_ENDPOINT, payload);
  return unwrapResponse(response);
}

export async function updateMissionGoal(axios, id, payload) {
  const response = await axios.patch(`${GOALS_ENDPOINT}${id}/`, payload);
  return unwrapResponse(response);
}
